import React from 'react';
import { withRenderers } from '~/utils';
import { tables } from '~/pages/projects/meta/data/finance.schema';
import { UseFinanceCalculation } from '~/pages/projects/types';
import { FinancePosition, getOriginalAndModalFromPosition } from './useFinance';
import { useModal } from '~/hooks';

export const useFinanceOfferCalculation = ({
    fixed = false,
    send,
    permissions = {},
}: UseFinanceCalculation & { permissions?: any }) => {
    const { dispatch, onOpen } = useModal();
    const { canEdit, canDelete, canView } = permissions;

    const controls = React.useMemo(
        () =>
            [
                {
                    title: canView && !canEdit ? 'Ansehen' : 'Bearbeiten',
                    enabled: () => canEdit || canView,
                    props: {
                        onClick: (row: any) => {
                            const position = (row?.original || {}) as FinancePosition;
                            const { original, modal } = getOriginalAndModalFromPosition(position);
                            dispatch?.({ type: 'setModal', data: { modal } });
                            send?.({
                                type: 'SET_CACHE',
                                cache: ({ cache = {} }: any = {}) => ({
                                    ...cache,
                                    row: original,
                                    rowId: original?.id,
                                }),
                            });
                            onOpen?.();
                        },
                    },
                },
                { title: 'divider', enabled: () => canDelete },
                {
                    title: 'Löschen',
                    enabled: () => canDelete,
                    props: {
                        color: 'red.400',
                        onClick: (row: any) =>
                            send?.({
                                type: 'DELETE_POSITION',
                                variables: { id: row?.original?.id },
                            }),
                    },
                },
            ].filter(Boolean),
        [canEdit, canDelete, canView]
    );

    const columns = React.useMemo(
        () => withRenderers(tables.positions.columns, controls),
        [controls]
    );
    const hiddenColumns =
        [...tables.positions.hiddenColumns, fixed && 'controls'].filter(Boolean) || [];

    return {
        columns,
        hiddenColumns,
    };
};
